import { render } from "./imageSimple.vue?vue&type=template&id=290e48d2"
import script from "./imageSimple.vue?vue&type=script&lang=js"
export * from "./imageSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__